import { StoreType } from "@omni/types/api/store/cloud/shared/enums/storeType.enum";
import { attempt } from "@omni/utils/function.utils";

import { Config } from "@/utils/config.utils";

import { addressMapper } from "./mappers/address.mapper";
import { storeMapper } from "./mappers/store.mapper";

const CountryOrder: Record<string, number> = {
    "be": 0,
    "nl": 1,
    "lu": 2
};

const byISOCode = (
    a: woosmap.map.localities.LocalitiesPredictions,
    b: woosmap.map.localities.LocalitiesPredictions
) => {
    const aISO = atob(a.public_id).split(":").at(1) ?? "";
    const bISO = atob(b.public_id).split(":").at(1) ?? "";
    return (CountryOrder[aISO] ?? 999) - (CountryOrder[bISO] ?? 999);
};

export const fetchAddressSearchItems = (
    localitiesService: woosmap.map.LocalitiesService,
    inputValue: string,
    limit?: number
) =>
    localitiesService
        .autocomplete({
            input: inputValue.toString(),
            components: {
                country: ["be", "nl", "lu"]
            },
            types: ["address", "locality", "postal_code"],
            language: Config.getLanguage()
        })
        .then(({ localities }) => {
            const hasISOCodecPublicId = attempt(() => {
                const firstResult = localities.at(0);

                return !!(
                    atob(firstResult?.public_id ?? "")
                        .split(":")
                        .at(1) ?? ""
                );
            }, undefined);

            if (!hasISOCodecPublicId) {
                throw new Error(
                    "No ISO code found in the first Woosmap result."
                );
            }

            return localities
                .filter((l) => !!l.matched_substrings)
                .sort(byISOCode)
                .slice(0, limit)
                .map(addressMapper);
        });

export const fetchStoreSearchItems = (
    storesService: woosmap.map.StoresService,
    inputValue: string,
    limit?: number,
    filterStoreType?: StoreType
) =>
    storesService
        .autocomplete({
            language: Config.getLanguage(),
            limit: limit,
            query: `localized:"${inputValue}" AND user.locale:="${Config.getLocale()}"${filterStoreType ? ` AND type:"${filterStoreType}"` : ""}`
        })
        .then(({ predictions }) =>
            predictions
                .filter((prediction) => !!prediction.matched_substrings)
                .map(storeMapper)
        );
